import { takeLatest, call, put } from 'redux-saga/effects';

import { statusCodes } from 'modules/common/enums';
import { addService, deleteService, editService, getServicesList, getSpecialities } from './api';
import {
  fetchSpecialitiesSuccess,
  fetchSpecialitiesFail,
  fetchServicesListSuccess,
  fetchServicesListFail,
  addOrEditServiceFail,
  addOrEditServiceSuccess,
  deleteServiceSuccess,
  deleteServiceFail,
} from './actions';
import servicesActionTypes from './action-types';

function* fetchSpecialitiesListSaga() {
  try {
    const response = yield call(getSpecialities);
    yield put(fetchSpecialitiesSuccess(response.data.Data));
  } catch (error) {
    yield put(fetchSpecialitiesFail(error));
  }
}

function* fetchServicesListSaga({ payload }) {
  try {
    const response = yield call(getServicesList, payload);
    yield put(fetchServicesListSuccess(response.data.data));
  } catch (error) {
    yield put(fetchServicesListFail(error));
  }
}

function* addOrEditServiceSaga({ payload }) {
  const { callbackAction, data } = payload;
  try {
    const { serviceKey } = data;
    data.serviceSpecialities = data.serviceSpecialities.map(item => {
      const { key } = item;
      return { specialityKey: key };
    });
    data.servicePreparations = data.servicePreparations.map(item => {
      const tempItem = { ...item };
      if (typeof tempItem.servicePreparationKey === 'number') delete tempItem.servicePreparationKey;
      return { ...tempItem };
    });
    data.servicePreparations = data.servicePreparations.filter(
      item => item.preparationNameEn !== '' && item.preparationNameAr !== '',
    );
    if (serviceKey) yield call(editService, data);
    else yield call(addService, data);
    callbackAction();
    yield put(addOrEditServiceSuccess());
  } catch (error) {
    if (error?.response?.status === statusCodes.conflict)
      yield put(addOrEditServiceFail('A Service with this Name already exists!'));
  }
}

function* deleteServiceSaga({ payload }) {
  const { callbackAction, data } = payload;
  try {
    yield call(deleteService, data);

    callbackAction();
    yield put(deleteServiceSuccess());
  } catch (error) {
    yield put(deleteServiceFail(error));
  }
}

function* servicesSaga() {
  yield takeLatest(servicesActionTypes.FETCH_SPECIALITIES, fetchSpecialitiesListSaga);
  yield takeLatest(servicesActionTypes.FETCH_SERVICES_LIST, fetchServicesListSaga);
  yield takeLatest(servicesActionTypes.ADD_OR_EDIT_SERVICE, addOrEditServiceSaga);
  yield takeLatest(servicesActionTypes.DELETE_SERVICE, deleteServiceSaga);
}

export default servicesSaga;
